/**
 * Creates a download link and triggers the download of a blob
 * @param blob - The blob to download
 * @param filename - The filename for the download
 */
export const downloadBlob = (blob: Blob, filename: string): void => {
  if (typeof window === 'undefined') return;

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();

  // Cleanup
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

/**
 * Creates a download link and triggers the download of a URL
 * @param url - The URL to download
 * @param filename - Optional filename for the download
 */
export const downloadUrl = (url: string, filename?: string): void => {
  if (typeof window === 'undefined') return;

  const link = document.createElement('a');
  link.href = url;
  if (filename) {
    link.download = filename;
  }
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
